import TestSuite from '../api/testSuite';

const Upload = {};
Upload.uploadFile = async (testSuiteGuid, file) => {
  const formData = new FormData();
  formData.append('file', file);
  return TestSuite.addExtension(testSuiteGuid, formData);
};

export default Upload;
